import { pick, keys, get, upperCase, map, values, sumBy, round, orderBy } from 'lodash';
import filesize from 'filesize.js';

export const buildStorageUsageData = bytes => {
    const allowedCategories = ['backup', 'database', 'ftp_transfer', 'logs', 'network_captures', 'recordings', 'voicemails'];
    const allowedBytes = pick(bytes, allowedCategories);
    const allowedBytesValues = values(allowedBytes);
    const usedSpace = sumBy(allowedBytesValues, value => +value);
    const categories = map(keys(allowedBytes), category => {
        const byte = +get(bytes, category);
        const parsedByte = filesize(byte * 1e3);
        const splittedParsedByte = parsedByte.split(' ');
        const percentage = round((byte * 1e5) / (usedSpace * 1e3), 2);

        return {
            name: category === 'voicemails' ? 'voicemail' : category,
            size: `${splittedParsedByte[0]} ${upperCase(splittedParsedByte[1])}`,
            percentage
        };
    });

    return orderBy(categories, ['percentage', 'size'], ['desc', 'asc']);
};
